import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import moment from 'moment';

import { Text, Heading, Icon } from '../../../Elements';
import { months } from './helpers/configurates';
import {
  generateYearsRange,
  getFullMonthName,
  getSmallMonthName
} from './helpers/helpers';

import classes from './SelectMMYY.module.scss';

const years = generateYearsRange();

const SelectMMYY = ({
  setIsOpenMMYY,
  isOpenMMYY,
  setSelectDate,
  minDate,
  maxDate
}) => {
  const [selectedMonth, setSelectedMonth] = useState(
    moment(new Date()).format('MM')
  );
  const [selectedYear, setSelectedYear] = useState(
    moment(new Date()).format('YYYY')
  );
  const [yearsEnabled, setYearsEnabled] = useState(
    minDate || maxDate ? true : false
  );
  const [monthEnabled, setMonthEnabled] = useState(
    minDate || maxDate ? false : true
  );

  const formatMinDateYear = minDate
    ? moment(new Date(minDate)).format('YYYY')
    : undefined;
  const formatMinDateMonth = minDate
    ? moment(new Date(minDate)).format('MM')
    : undefined;
  const formatMaxDateYear = maxDate
    ? moment(new Date(maxDate)).format('YYYY')
    : undefined;
  const formatMaxDateMonth = maxDate
    ? moment(new Date(maxDate)).format('MM')
    : undefined;

  useEffect(() => {
    setSelectDate(new Date(`${selectedMonth}/01/${selectedYear}`));
    if (!minDate && !maxDate) {
      if (yearsEnabled) {
        setIsOpenMMYY(false);
      }
    }
    // eslint-disable-next-line
  }, [selectedYear]);

  useEffect(() => {
    setSelectDate(new Date(`${selectedMonth}/01/${selectedYear}`));
    if (minDate || maxDate) {
      if (monthEnabled) {
        setIsOpenMMYY(false);
      }
    }
    // eslint-disable-next-line
  }, [selectedMonth]);

  const handleMonth = month => {
    if (!minDate && !maxDate) {
      setYearsEnabled(true);
      setSelectedMonth(month);
    } else {
      if (month === selectedMonth) {
        setIsOpenMMYY(false);
        return;
      }
      setSelectedMonth(month);
    }
  };

  const handleYear = year => {
    if (!minDate && !maxDate) {
      if (year === selectedYear) {
        setIsOpenMMYY(false);
        return;
      }
      setSelectedYear(year);
    } else {
      setMonthEnabled(true);
      setSelectedYear(year);
    }
  };

  const validationCheckedM = month => {
    if ((minDate || maxDate) && monthEnabled) {
      if (
        selectedYear > formatMinDateYear &&
        selectedYear < formatMaxDateYear
      ) {
        return true;
      } else if (
        selectedYear === formatMinDateYear &&
        selectedYear !== formatMaxDateYear
      ) {
        if (Number(month) >= Number(formatMinDateMonth)) {
          return true;
        } else {
          return false;
        }
      } else if (
        selectedYear === formatMaxDateYear &&
        selectedYear !== formatMinDateYear
      ) {
        if (Number(month) <= Number(formatMaxDateMonth)) {
          return true;
        } else {
          return false;
        }
      } else if (
        selectedYear === formatMinDateYear &&
        selectedYear === formatMaxDateYear
      ) {
        if (
          Number(month) >= Number(formatMinDateMonth) &&
          Number(month) <= Number(formatMaxDateMonth)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return monthEnabled ? true : false;
    }
  };

  const blockMM = months.map(month => (
    <div
      key={month}
      className={cn(
        classes.monthWrap,
        month === selectedMonth && classes.selectedMonth,
        !monthEnabled &&
          month === selectedMonth &&
          classes.selectedMonth_disabled
      )}
      onClick={validationCheckedM(month) ? () => handleMonth(month) : () => {}}
    >
      <Text
        className={cn(
          (!monthEnabled || !validationCheckedM(month)) &&
            (month !== selectedMonth
              ? classes.disabledYear
              : (classes.disabledYear, classes.disabledYear_selected))
        )}
      >
        {getSmallMonthName(month)}
      </Text>
    </div>
  ));

  const validationCheckedY = year => {
    return minDate || maxDate
      ? (minDate ? Number(year) >= Number(formatMinDateYear) : true) &&
        (maxDate ? Number(year) <= Number(formatMaxDateYear) : true)
        ? true
        : false
      : yearsEnabled
      ? true
      : false;
  };

  const blockYY = years.map(year => (
    <div
      key={year}
      className={cn(
        classes.monthWrap,
        year === selectedYear &&
          (yearsEnabled
            ? classes.selectedMonth
            : classes.selectedMonth_disabled)
      )}
      onClick={validationCheckedY(year) ? () => handleYear(year) : () => {}}
    >
      <Text
        className={cn(
          (!yearsEnabled || !validationCheckedY(year)) &&
            (year !== selectedYear
              ? classes.disabledYear
              : (classes.disabledYear, classes.disabledYear_selected))
        )}
      >
        {year}
      </Text>
    </div>
  ));

  return (
    <div className={classes.windowPicker}>
      <Heading
        className={classes.currentDate}
        onClick={() => setIsOpenMMYY(!isOpenMMYY)}
      >
        {getFullMonthName(selectedMonth)} {selectedYear}
        <Icon size="16px" icon={'arrow'} className={classes.date_arrow} />
      </Heading>
      <div className={cn(classes.monthsWrap, classes.monthsWrap_line)}>
        {maxDate || minDate ? blockYY : blockMM}
      </div>
      <div className={classes.monthsWrap}>
        {maxDate || minDate ? blockMM : blockYY}
      </div>
    </div>
  );
};

SelectMMYY.propTypes = {
  setSelectDate: PropTypes.func.isRequired,
  setIsOpenMMYY: PropTypes.func.isRequired,
  isOpenMMYY: PropTypes.bool.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object
};

export default SelectMMYY;
